import { render, staticRenderFns } from "./box-line.vue?vue&type=template&id=8220fcc6&"
var script = {}
import style0 from "./box-line.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports